import store from '@/store';
import AppService, { Applications } from '@/core/services/app.service';
import RouteNames from '@/constants/route-names';

const routeNames = RouteNames;

const ifNotAuthenticated = (to: any, from: any, next: any) => {
    if (!store.getters.isAuthenticated) {
      next();
      return;
    }
    redirectToApp(to, from, next);
};

const ifAuthenticated = (to: any, from: any, next: any) => {
    if (
        store.getters.isAuthenticated ||
        to.name === routeNames.cbPurchase ||
        to.name === routeNames.cbPurchaseCompanion
    ) {
        next();
        return;
    }
    next('/login');
};

const cleanConvocationList = (to: any, from: any, next: any) => {
    store.dispatch('setConvocationsList', []);
    next();
    return;
};

const redirectToApp = (to: any, from: any, next: any) => {
    if (Applications.manager === AppService.current()) {
        next({ name: 'app' });
    } else if (Applications.clickbuy === AppService.current()) {
        next({ name: 'cb' });
    } else {
        next();
    }
};

const root = (to: any, from: any, next: any) => {
    if (store.getters.isAuthenticated) {
        redirectToApp(to, from, next);
    } else {
        next({ name: 'login' });
    }
};

const middlewares = {
    ifAuthenticated,
    ifNotAuthenticated,
    cleanConvocationList,
    root,
};

export default middlewares;
